module.exports = __webpack_public_path__ + "static/media/email_sm.bb8efe2491263b1444ca028be5fcf29c.svg";